import type { ModalKey, ModalPayloads } from './modal.type'

type OpenHandler = <K extends ModalKey>(
  key: K,
  payload: ModalPayloads[K],
) => void

type CloseHandler = () => void

let openHandlerRef: OpenHandler | undefined
let closeHandlerRef: CloseHandler | undefined

export function setOpenHandler(handler: OpenHandler | undefined) {
  openHandlerRef = handler
}

export function setCloseHandler(handler: CloseHandler | undefined) {
  closeHandlerRef = handler
}

export function openModal<K extends ModalKey>(
  key: K,
  payload: ModalPayloads[K],
): boolean {
  if (!openHandlerRef) {
    if (process.env.NODE_ENV !== 'production') {
      // no-op if provider not mounted
      console.warn('No open handler found for modal registry: ', key)
    }
    return false
  }

  openHandlerRef(key, payload)
  return true
}

export function closeModal(): void {
  closeHandlerRef?.()
}
